/**
 * Analytics aggregate hook (F15).
 *
 * Lives in `lib/` because two features consume it — the analytics screen and
 * the quarterly report. The request itself is in `analytics.api` so a test can
 * stub it (see the note there).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md tasks 10.1, 10.3, §3.1
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { Analytics } from '@nexus/contracts';

import * as analyticsApi from './analytics.api';
import { queryKeys } from './query-keys';

export function useAnalytics(): UseQueryResult<Analytics> {
  return useQuery({
    queryKey: queryKeys.analytics.all,
    queryFn: () => analyticsApi.getAnalytics(),
  });
}
